import useSWR from 'swr';

let cachedCurrentVersion = null; // Store the current version in memory after the first fetch

const fetcher = async (url) => {
  const noCache = Date.now();
  return fetch(`${url}?nocache=${noCache}`).then((r) => r.text());
};

// Fetch the current version from version.txt only once and store it in memory
const useCurrentVersion = () => {
  const { data, error } = useSWR(
    cachedCurrentVersion ? null : 'currentVersion', // Custom key for current version
    () => fetcher('/version.txt'),
    {
      revalidateOnFocus: false, // Do not refetch when the window gains focus
      revalidateOnReconnect: false, // Do not refetch when reconnecting
    }
  );

  if (!data || error) {
    return cachedCurrentVersion;
  }

  if (data && typeof data === 'string') {
    cachedCurrentVersion = data.trim(); // Cache the current version in memory
    return cachedCurrentVersion;
  }

  return cachedCurrentVersion;
};

// Fetch the latest version (if stored somewhere else, e.g., an API or another source)
const useGetLatestVersion = () => {
  const { data, error } = useSWR(
    'latestVersion', // Custom key for latest version
    () => fetcher('/version.txt')
  );

  if (!data || error) {
    return null;
  }

  if (data && typeof data === 'string') {
    return data.trim();
  }

  return null;
};

export { useCurrentVersion, useGetLatestVersion };
